import timg1 from '../images/team/dentist_.JPG'
import timg2 from '../images/team/Vanessa.jpg' 
import timg3 from '../images/team/Kaylee.jpg'
import timg4 from '../images/team/Jocelyn.jpeg'
import timg5 from '../images/team/Alana.jpeg'
// import timg6 from '../images/team/employee5.jpeg'
const Teams = [
   {
      id: '1',
      tImg: timg1,
      name: 'Dr. Tri Tran, D.M.D',
      title: 'Principal Dentist',
   },
   {
      id: '2',
      tImg: timg2,
      name: 'Vanessa Lunford',
      title: 'Office Manager',
   },
   {
      id: '3',
      tImg: timg3,
      name: 'Kaylee Graves',
      title: 'Front Desk',
   },
   {
      id: '4',
      tImg: timg4,
      name: 'Jocelyn Schupp',
      title: 'Registered Dental Assistant',
   },
   {
      id: '5',
      tImg: timg5,
      name: 'Alana Miller',
      title: 'Dental Assistant',
   },

]

export default Teams;